import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import SingleSelect from "../../common/SingleSelect";
import { accountFieldStyle } from "./formOptions";

const UserTypeSection = (props) => (
  <Fragment>
              {!props.editOption && (
                <Grid container spacing={2}>
                  <Grid item md={3} sm={6} xs={12}>
                    <TextField
                      id="userType"
                      select
                      label={props.translate("userType")}
                      value={props.form.userType || ""}
                      onChange={props.handleChange("userType")}
                      SelectProps={{
                        MenuProps: {
                          className: props.classes.menu,
                        },
                      }}
                      margin="dense"
                      fullWidth
                      error={Boolean(props.addUserFieldErrors?.userType)}
                      // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                      required
                    >
                      <MenuItem value="">
                        <em>{props.translate("none")}</em>
                      </MenuItem>
                      {props.userTypeArray.length &&
                        props.userTypeArray.map((option) => (
                          <MenuItem key={option.key} value={option.key}>
                            {props.translate(option.name)}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  {!props.editOption && props.form.userType > 2 && (
                    <Grid
                      item
                      sm={6}
                      md={3}
                      xs={12}
                      style={accountFieldStyle("searchCompany", { zIndex: 99 })}
                    >
                      <SingleSelect
                        array={props.defaultCompaniesList || []}
                        async
                        selectName="companyId"
                        isClearable
                        // loadOptions={props.searchAccountsList.bind()}
                        label={
                          <p style={{ fontSize: "0.9rem" }}>
                            {props.translate("searchCompany")}
                          </p>
                        }
                        value={
                          props.companySelectedData &&
                          props.companySelectedData.id
                            ? {
                                id: props.companySelectedData.id,
                                value: props.companySelectedData.id,
                                label: props.companySelectedData.label,
                              }
                            : null
                        }
                        handleChange={props.timezone_handleChange}
                        canAssign={true}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            ...(props.addUserFieldErrors?.companyId
                              ? {
                                  // backgroundColor: "rgba(211, 47, 47, 0.12)",
                                  borderColor: "red",
                                  // boxShadow: state.isFocused
                                  // ? "0 0 0 1px #d32f2f"
                                  // : "none",
                                }
                              : {}),
                          }),
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              )}
  </Fragment>
);

export default UserTypeSection;
